import { Pipe, PipeTransform, inject } from '@angular/core';
import { FeatureFlagsService } from '../feature-flags.service';

/**
 * A pipe that returns a boolean indicating whether a feature flag is enabled.
 * @example
 * ```html
 * <div *ngIf="'feature-flag-name' | featureFlagSignal">
 *   Feature flag is enabled
 * </div>
 * ```
 */
@Pipe({
  name: 'featureFlagSignal',
  standalone: true,
  pure: false,
})
export class FeatureFlagSignalPipe implements PipeTransform {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  transform(value: string): boolean {
    const flags = this.featureFlagsService.flagSignal();
    return flags?.[value] ?? false;
  }
}
